



















































import Vue from 'vue';
import { snsVerify } from '@bilibili/sns-login'
import { initEnv, biliBridge, isSupport } from '@bilibili/js-bridge';
import { isApp, isiOS, u } from '../utils'
import { lock, unlock } from 'tua-body-scroll-lock'
import '@bilibili/sns-login/dist/sns-login.css'
import { init, openApp } from '@bilibili/h5-utils'
import { parseParamToObj } from '@plat-components/utils2/_esm5/url';
import logger from '@plat-components/utils2/_esm5/logger';
import Toast from '@bilibili/h5-vue-toast'
import request from '@plat-components/utils2/_esm5/request';
import TopBanner from '../components/TopBanner.vue'

const API = {
  LOGIN: '//api.bilibili.com/x/web-interface/nav',
  COUPN: '//api.bilibili.com/x/activity/brand/coupon'
}

Vue.prototype.$toast = new Toast({ 
  duration: 10000,
  // timeout: 10000
})

// 初始化h5跳转
init()

export default Vue.extend({
  name: 'home',
  components: {
    TopBanner,
  },
  data() {
    return {
      isReceived: false,
      isLogin: false,
      inApp: false,
      couponType: 1,
      scrollY: 0,
      isFirstFocus: true,
      loginCD: false,
      isNewJoiner: false,
      pauseAnime: true,
      activity_from: '',
      activity_name: 'guanggaochengjie1',
    }
  },
  mounted() {
    this.pauseAnimation()
    console.log(parseParamToObj(window.location).from);
    if (parseParamToObj(window.location).from) {
      this.activity_from = parseParamToObj(window.location).from
    }
    // console.log(isApp);
    // console.log('获取登录状态....');
    // 初始化埋点参数
    let pageParams = {
      activity_name: this.activity_name,
      activity_from: this.activity_from,
      pagestate_type: 1
    }
    // 判断是否在我们 App 内
    if (isApp) {
      // initEnv 为必须，调用一次即可,兼容旧环境
      initEnv()
      this.inApp = true
      let _this = this
      // 判断该方法是否在该版本app的webview上，建议每次调用新方法时候都先调用isSupport方法
      isSupport('auth.login')
      .then((support) => {
        if (support) {
          biliBridge.callNative({
            method:'auth.getUserInfo',
            data: {
              type: 'default',
            },
            callback: function (userInfo) {
              // console.log('userInfo',userInfo)
              if(userInfo.state == 0) {
                // state 安卓为'0', ios 为 0
                _this.isLogin = false
              } else {
                _this.isLogin = true
              }
            }
          });
        } else {
          console.log('not support')
        }
      })
    } else {
      this.syncLogin()
      .then((res: any) => {
        // console.log('登录状态：',res);
        this.isLogin = res.data.isLogin
        // 自定义上报
        pageParams.pagestate_type = 2
        logger('page', pageParams)
        // console.log('登录状态：已登录');
      })
      .catch(error => {
        if (error.code === -101) {
          this.isLogin = error.data.isLogin
          logger('page', pageParams)
          // console.log('登录状态：未登录');
        }
      })
    }
  },
  methods: {
    handleLogin() {
      return
      // console.log('isLogin:', this.isLogin);
      if (this.loginCD) return
      if (this.isLogin) {
        this.loginCD = true
        this.toast().info('正在领取...')
        this.handleGetCoupon()
      } else {
        if (this.inApp) {
          let _this = this
          biliBridge.callNative({
            method:'auth.login',
            data: {
              type: 'default',
              // callbackUrl: 'http://www.baidu.com'// 不传返回直接关闭登陆窗口，返回原来页面
            },
            onLogin (data) {
              // 安卓无论成功失败都会回调，ios 只有登陆成功会回调
              // 0: { not login, faild, canceled } 1: logined
              // console.log('onLoginCallback', data)
              if (data.state === 1) {
                this.isNewJoiner = false
                _this.toast().info('正在领取...')
                _this.handleGetCoupon()
              }
            },
            callback: function(){
              // console.log('调起登陆窗口')
            }
          });
        } else {
          snsVerify()
          .then((fastRegister: any) => {
            this.scrollY = window.scrollY
            lock()
            fastRegister.showComponent()
            let inputList = document.querySelectorAll('.login-mask .form-container .text-box-middle input')
            console.log(inputList);
            inputList.forEach(input => {
              console.log(input);
              this.listenKeybord(input);
            })
            fastRegister.addEventListener('login-success', (res: any) => {
              // console.log('登录成功', res);
              unlock()
              window.scrollTo(0,this.scrollY);
              this.isLogin = true
              // 是否是新注册用户
              this.isNewJoiner = res.is_new
              this.toast().info('正在领取...')
              this.handleGetCoupon()
            })
            fastRegister.addEventListener('login-cancel', () => {
              unlock()
              window.scrollTo(0,this.scrollY);
            })
          })
          .catch(err => {
            unlock()
            window.scrollTo(0,this.scrollY);
            this.toast().info('登录失败')
            setTimeout(()=> {
              this.toast().stop()
            }, 1500)
          })
        }
      }
    },
    handleOpenApp() {
      openApp({
        schema: 'bilibili://home',
        universalLink: 'http://m.bilibili.com/index.html',
        delayDownload: true
      })
    },
    openInApp() {
      logger('download')
      let url = window.location.href
      openApp({
        schema: `bilibili://browser?url=${url}`,
        universalLink: url,
        delayDownload: true
      })
    },
    switchResult(flag, type?) {
      this.isReceived = flag
      this.couponType = type
    },
    syncLogin() {
      return new Promise((resolve, reject) => {
        request({
          method: 'get',
          url: API.LOGIN
        })
        .then(res => {
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
      })
    },
    requestCoupon() {
      return new Promise((resolve, reject) => {
        request({
          method: 'post',
          url: API.COUPN
        })
        .then(res => {
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
      })
    },
    handleGetCoupon() {
      this.requestCoupon()
      .then((res: any) => {
        // console.log('res:',res.message);
        window.scrollTo(0,0);
        this.toast().stop()
        this.loginCD = false
        let couponType = res.data.coupon_type
        // 自定义上报
        let receiveType
        if (this.isNewJoiner) {
          receiveType = 1
        } else {
          // 老用户新会员
          if (couponType === 1) {
            receiveType = 2
          } else if (couponType === 2) {
            // 老用户老会员
            receiveType = 3
          }
        }
        logger('receive', {
          activity_name: this.activity_name,
          activity_from: this.activity_from,
          receive_type: receiveType
        })
        this.switchResult(true, couponType)
      })
      .catch(error => {
        // console.log('err', error);
        this.loginCD = false
        this.switchResult(false)
        this.toast().stop()
        this.toast().info(error.message)
        // 自定义上报
        let receiveType
        if (error.code === 75703) {
          receiveType = 0
        }
        logger('receive', {
          activity_name: this.activity_name,
          activity_from: this.activity_from,
          receive_type: receiveType
        })
        setTimeout(()=> {
          this.toast().stop()
        }, 1500)
      })
    },
    toast() {
      return (this as any).$toast
    },
    pauseAnimation() {
      let playAndPused = () => {
        setTimeout(()=> {
          this.pauseAnime = false
          setTimeout(() => {
            this.pauseAnime = true
            playAndPused()
          }, 1000)
        }, 1000)
      }
      playAndPused()
    },
    listenKeybord($input) {
      if (isiOS) {
        // IOS 键盘弹起：IOS 和 Android 输入框获取焦点键盘弹起
        $input.addEventListener('focus', function () {
          // activeElementScrollIntoView(this, 1000);
        }, false)

        // document.addEventListener('blur', (e) => {
        //   if (e.target) {
        //     document.body.scrollIntoView(false);
        //   }
        // });

        // IOS 键盘收起：IOS 点击输入框以外区域或点击收起按钮，输入框都会失去焦点，键盘会收起，
        $input.addEventListener('blur', () => {
          // 微信浏览器版本6.7.4+IOS12会出现键盘收起后，视图被顶上去了没有下来
          var wechatInfo = window.navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i) || [];
          if (!wechatInfo) return;

          var wechatVersion = wechatInfo[1] || "";
          var version = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/) || [];

          if (u.indexOf("QQ/") > -1 || u.indexOf("_weibo_") > -1) {
            window.scrollBy(0, 3);
          }

          if (+wechatVersion.replace(/\./g, '') >= 674 && +version[1] >= 12) {
            window.scrollBy(0, 3);
            // window.scrollTo(0, Math.max(document.body.clientHeight, document.documentElement.clientHeight));
          }
        })
      }
      // Andriod 键盘收起：Andriod 键盘弹起或收起页面高度会发生变化，以此为依据获知键盘收起
      if (!isiOS) {
        var originHeight = document.documentElement.clientHeight || document.body.clientHeight;
        // let self = this;
        window.addEventListener('resize', function () {
          var resizeHeight = document.documentElement.clientHeight || document.body.clientHeight;
          if (originHeight < resizeHeight) {
            // 非iOS键盘收起
          } else {
            // 非iOS键盘弹出
            // self.activeElementScrollIntoView($input, 1000);
          }
          originHeight = resizeHeight;
        }, false)
      }
    },
  }
})
